import makeStyles from '@mui/styles/makeStyles';

const useAutocompleteStyles = makeStyles({
  container: {
    display: "inline-flex",
  },
});

export default useAutocompleteStyles;
